import { AuthState } from './types';

export const initialState: AuthState = {
  accessToken: null,
  userDetails: null,
};